import React, { useEffect, useState } from 'react';
import { Button, IcoGridView, IcoListView } from '../../../component';
import './charts.scss';
import { useDispatch, useSelector } from 'react-redux';
import { closeAllCharts } from '../redux/dashboardActions';
import SocioeconomicDemographicCharts from '../socioeconomicDemographic/charts';
import TransactionsCharts from '../realtyTransactions/components/charts';
import { setIsGridView } from './redux/charts.actions';

import {
  PrimaryCharts,
  PrimaryChartsEcoMap,
} from '../realtyOffersPrimary/components/charts';

import MarketCycleCharts from '../marketCycle/components/charts/marketCycleCharts';
import SecondaryCharts from '../realtyOffersSecondary/components/charts/secondaryCharts';

import { PrimaryCharts as GeneralPrimaryCharts } from '../realtyOffersPrimaryGeneral/components/charts';
import { SecondaryCharts as GeneralSecondaryCharts } from '../realtyOffersSecondaryGeneral/components/charts';
import { TransactionsCharts as GeneralTransactionsCharts } from '../realtyTransactionsGeneral/components/charts';

interface DisplayChartsMapper {
  primaryMarket: JSX.Element;
  primaryMarketEcoMap: JSX.Element;
  primaryMarketGeneral: JSX.Element;
  secondaryMarket: JSX.Element;
  secondaryMarketGeneral: JSX.Element;
  transactions: JSX.Element;
  transactionsGeneral: JSX.Element;
  marketCycle: JSX.Element;
  socioeconomicDemographic: JSX.Element;
}

const DISPLAY_CHARTS_MAPPER: DisplayChartsMapper = {
  primaryMarket: <PrimaryCharts />,
  primaryMarketGeneral: <GeneralPrimaryCharts />,
  primaryMarketEcoMap: <PrimaryChartsEcoMap />,
  secondaryMarket: <SecondaryCharts />,
  secondaryMarketGeneral: <GeneralSecondaryCharts />,
  transactions: <TransactionsCharts />,
  transactionsGeneral: <GeneralTransactionsCharts />,
  marketCycle: <MarketCycleCharts />,
  socioeconomicDemographic: <SocioeconomicDemographicCharts />,
};

export const ChartsPage: React.FC = () => {
  const dispatch = useDispatch();

  const { marketType, displayCharts } = useSelector(
    (state: any) => state.dashboardState
  );

  const {
    realtyType,
    minUsefulArea,
    maxusefulArea,
    minDate,
    maxDate,
    isGridView,
  } = useSelector((state: any) => state.chartsState) || '';

  const { displayChartsSocioeconomicDemographic } = useSelector(
    (state: any) => state.socioeconomicDemographicState
  );

  const addingSmoothBehaviorAllAnchorElements = () => {
    document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();

        // @ts-ignore: this
        document.querySelector(this.getAttribute('href')).scrollIntoView({
          behavior: 'smooth',
        });
      });
    });
  };

  useEffect(() => {
    addingSmoothBehaviorAllAnchorElements();
    return () => {
      dispatch(closeAllCharts());
    };
  }, []);

  return (
    <div className="charts-page--full-container" id="charts-page">
      <div className="charts-page--header">
        <div className="charts-page--header-text-container">
          <h6
            className="charts-page--header-text-container-title"
            data-cy="ChartsPageHeaderTitle"
          >
            Indicadores da Região
          </h6>
          {!displayChartsSocioeconomicDemographic ||
            (marketType === 'market cycle' && (
              <p
                className="charts-page--header-text-container-infos"
                data-cy="ChartsPageHeaderInfos"
              >
                Exibindo resultados para: {realtyType && realtyType}; &gt;{' '}
                {minUsefulArea}m², &lt; {maxusefulArea}m²; {minDate} a {maxDate}
              </p>
            ))}
        </div>

        <div className="charts-page--header-buttons-container">
          <Button
            cy="GridView"
            className={`btn normal medium ${
              isGridView ? 'primary' : 'secondary'
            }`}
            onClick={() => {
              dispatch(setIsGridView(true));
            }}
          >
            <IcoGridView cy="ChartPage" />
          </Button>
          <Button
            cy="ListView"
            className={`btn normal medium ${
              isGridView ? 'secondary' : 'primary'
            }`}
            onClick={() => {
              dispatch(setIsGridView(false));
            }}
          >
            <IcoListView cy="ChartPage" />
          </Button>
        </div>
      </div>
      <div className="charts-page--content">
        {displayCharts &&
          DISPLAY_CHARTS_MAPPER[
            `${displayCharts}` as keyof DisplayChartsMapper
          ]}
      </div>
    </div>
  );
};
